export const DOCUMENT_TYPE = {
    schematics: "Schematic",
};

export const PAGE_CONTEXT = {
    retailModeSettingsPage: "RetailModeSettingsPage",
    accountReceivablePage: "AccountReceivablePage",
    invoicePaymentConfirmationPage: "InvoicePaymentConfirmationPage",
    statementOptionsPage: "StatementOptionsPage",
    paymentHistoryPage: "PaymentHistoryPage",
};

export const WIDGET_GROUP = {
    retailMode: "Retail Mode",
    invoicePayment: "Invoice Payment",
};

export const API_ERROR_CODE = {
    timeout: "408",
};

export const ORDER_STATUS = {
    open: "OPEN",
    invoiced: "INV",
};

export const USER_ROLES = {
    administrator: "Administrator",
    buyer1: "Buyer1",
    buyer2: "Buyer2",
    buyer3: "Buyer3",
    // policies
    displayNoPrice: "DisplayNoPrice",
    canPlaceOrder: "CanPlaceOrder",
};

export const ROLES_REQUIRING_APPROVER = [USER_ROLES.buyer1, USER_ROLES.buyer2];

export const PAGE_TYPES = {
    accountReceivable: "AccountReceivablePage",
    retailPricingSettings: "RetailModeSettingsPage",
    accountSettings: "AccountSettingsPage",
    addresses: "AddressesPage",
    budgetManagement: "BudgetManagementPage",
    invoiceHistory: "InvoiceHistoryPage",
    myLists: "MyListsPage",
    orderHistory: "OrderHistoryPage",
    myQuotes: "RfqMyQuotesPage",
    savedPayments: "SavedPaymentsPage",
    changeCustomer: "ChangeCustomerPage",
    orderApproval: "OrderApprovalListPage",
    userAdministration: "UserListPage",
    savedOrderList: "SavedOrderListPage",
    statementOptions: "StatementOptionsPage",
};

export const DATE_FORMAT = {
    date: "MM/dd/y",
    dateTime: "MM/dd/y h:mm a",
};

export const ATTRIBUTE_TYPE_NAMES = {
    availability: "WarehouseAvailability",
    stocking: "WarehouseStocking",
    featuredBullets: "ProductFeaturedBullets",
};

export const COOKIES = {
    branchDistanceUom: "branch_distance_uom",
    branchSelectorRadius: "branch_selector_radius",
    geolocationStatus: "geolocation_status",
    geolocationHomebranch: "geolocation_homebranch",
}